import styled, { css } from 'styled-components';
import { media } from '@ciam/theme';
const sizeStyles = {
    xs: css `
    ${({ theme }) => theme.getFontStyle('samsung-700-14')};
    height: 30px;
  `,
    s: css `
    ${({ theme }) => theme.getFontStyle('samsung-700-16')};
    height: 40px;
  `,
    m: css `
    ${({ theme }) => theme.getFontStyle('samsung-700-16')};
    height: 44px;

    ${media.tablet(css `
      height: 50px;
    `)}
  `,
    l: css `
    ${({ theme }) => theme.getFontStyle('samsung-700-18')};
    height: 60px;
  `,
};
const themeStyles = {
    white: css `
    color: ${({ theme }) => theme.getColor('gray', '02')};
    border: 1px solid ${({ theme }) => theme.getColor('gray', '05')};
    background-color: ${({ theme }) => theme.getColor('white')};

    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.getColor('primary', 'light')};
    }
  `,
    black: css `
    color: ${({ theme }) => theme.getColor('white')};
    background-color: ${({ theme }) => theme.getColor('gray', '01')};

    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.getColor('black')};
    }
  `,
    error: css `
    color: ${({ theme }) => theme.getColor('white')};
    background-color: ${({ theme }) => theme.getColor('error', 'default')};

    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.getColor('error', 'dark')};
    }
  `,
    'lined-error': css `
    color: ${({ theme }) => theme.getColor('error', 'default')};
    border: 1px solid ${({ theme }) => theme.getColor('error', 'default')};
    background-color: ${({ theme }) => theme.getColor('white')};

    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.getColor('error', 'light')};
    }
  `,
    blue: css `
    color: ${({ theme }) => theme.getColor('white')};
    background-color: ${({ theme }) => theme.getColor('primary', 'default')};

    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.getColor('primary', 'dark')};
    }
  `,
    'lined-blue': css `
    color: ${({ theme }) => theme.getColor('primary', 'default')};
    border: 1px solid ${({ theme }) => theme.getColor('primary', 'default')};
    background-color: ${({ theme }) => theme.getColor('white')};

    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.getColor('primary', 'light')};
    }
  `,
    none: css `
    background-color: ${({ theme }) => theme.getColor('white')};
    color: ${({ theme }) => theme.getColor('primary', 'default')};
  `,
};
export const StyledButton = styled.button `
  border-radius: 8px;
  width: 100%;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  ${(props) => sizeStyles[props.$size]}
  ${(props) => themeStyles[props.$buttonTheme]}
`;
//# sourceMappingURL=Button.styles.js.map